export const LIB_VERSION = '1.308.0'; // autogenerated
